export default function throttle(callback: (any: any) => any, delay: number) {
    let timer: string | number | NodeJS.Timeout | undefined;
    return function (...args: any[]) {
        clearTimeout(timer);
        timer = setTimeout(() => callback.apply(this, args), delay);
    };
}
